module.exports = __webpack_public_path__ + "img/back.53e0a8af.svg";